import { render, staticRenderFns } from "./exploracao.vue?vue&type=template&id=eda666a0&scoped=true&"
import script from "./exploracao.vue?vue&type=script&lang=js&"
export * from "./exploracao.vue?vue&type=script&lang=js&"
import style0 from "./exploracao.vue?vue&type=style&index=0&id=eda666a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda666a0",
  null
  
)

export default component.exports